import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemUser from '../assets/images/user.jpg';
import Cookies from 'react-cookies';

import {
	getLista, getListaTerceiros, getListaEntradas, getListaSaidas, getListaTransferencias,
	getListaUnidade, getListaProduto , getListaPosicaoVeiculo, getListaManual, getListaEstoqueBase
} from './dashboardActions';

import contentCardBody from '../common/template/contentCardBody';

// ============================================================
// Tokens de design — paleta, cores de status e helpers visuais
// ============================================================
const TOKENS = {
	bg: '#f4f6fb',
	cardBg: '#ffffff',
	cardRadius: 16,
	cardShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06)',
	border: '#edf0f5',
	textPrimary: '#0f172a',
	textMuted: '#64748b',
	headerGradient: 'linear-gradient(120deg, #43557a 0%, #43557a 60%, #43557a 100%)',
	headerGradientSoft: 'linear-gradient(120deg, #5c719e 0%, #5c719e 100%)',
	accent: '#3b6df4',
};

const PRODUTO_STYLE = {
	1: { bg: '#fef3c7', text: '#92400e', dot: '#d97706', label: 'S10' },     // S10
	3: { bg: '#ffe4d6', text: '#9a3412', dot: '#ea580c', label: 'S500' },    // S500
};

const STATUS_DISPONIBILIDADE = {
	baixo:  { bg: '#ef4444', text: '#ffffff', dot: '#ef4444' },
	medio:  { bg: '#eab308', text: '#ffffff', dot: '#eab308' },
	alto:   { bg: '#22c55e', text: '#ffffff', dot: '#22c55e' },
};

const PROGRAMADO_STYLE = { bg: '#3b82f6', text: '#ffffff', dot: '#1d4ed8' };

const pillStyle = (bg, text) => ({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: 6,
	padding: '5px 12px',
	borderRadius: 999,
	background: bg,
	color: text,
	fontWeight: 600,
	fontSize: 13,
	lineHeight: 1.2,
	whiteSpace: 'nowrap',
	minWidth: 80
});

const dotStyle = (color) => ({
	width: 7,
	height: 7,
	borderRadius: '50%',
	background: color,
	flex: '0 0 auto',
});

class Dashboard extends Component {

	state = {
		pesquisar: '',
		filtro: {
			id_unidades: []
		}
	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		this.atualizarLista();

		this.idInterval = setInterval(() => {
			this.atualizarLista();
		}, 60000);
    }

	componentWillMount() {

		const cookieFiltro = Cookies.load('dashboardFiltro');

		if (cookieFiltro) {
			this.setState({
				...this.state,
				filtro: {
					...cookieFiltro
				}
			});
		}

	}

	componentWillUnmount() {
		clearInterval(this.idInterval);
	}

	atualizarLista() {
		this.props.getListaUnidade();
		this.props.getListaProduto();
		this.props.getListaEstoqueBase();
		this.props.getLista();
		this.props.getListaTerceiros();
		this.props.getListaEntradas();
		this.props.getListaSaidas();
		this.props.getListaTransferencias();
		this.props.getListaPosicaoVeiculo();
		this.props.getListaManual();
	}

	setFiltro(filtro) {

		Cookies.save('dashboardFiltro', JSON.stringify({
			...filtro
		}), { path: '/' });

		this.setState({
			filtro: {
				...filtro
			}
		});

	}

	buscarSaldoEstoqueBase(id_unidade, id_produto) {
		let saldoCalculado = 0;

		const unidadeLocal = [1, 3, 9, 60].includes(id_unidade); //AB, BG, PN, SE

		if (unidadeLocal) {
			this.props.listaEstoqueBase.filter(item => {
				if (!id_unidade || item.id_unidade != id_unidade) {
					return 0;
				}
				if (!id_produto || item.id_produto != id_produto) {
					return 0;
				}
				return true;
			}).forEach(item => {
				//Começa a contar com esse estoque a partir daqui - se houver alterações anteriores não irá aplicar daqui para frente
				if (item.nome_tipo == 'Ajuste de Saldo') {
					saldoCalculado = parseFloat(item.quantidade_estoque);
				} else {
					saldoCalculado += parseFloat(item.quantidade_estoque);
				}
			});
		} else {
			const registroManual = this.props.listaManual.filter(manual => manual.id_unidade == id_unidade && manual.id_produto == id_produto).pop();

			saldoCalculado = parseFloat(registroManual ? registroManual.quantidade : 0);
		}

		return saldoCalculado;
	}

	// Classifica a disponibilidade em baixo / médio / alto, no mesmo critério original
	classificarDisponibilidade(disponibilidade, estoqueMinimo) {
		const disp = parseFloat(disponibilidade || 0);
		const minimo = parseFloat(estoqueMinimo || 0);

		if (disp <= minimo) {
			return 'baixo';
		} else if (disp <= minimo + (minimo * 1.3)) {
			return 'medio';
		}
		return 'alto';
	}

    render() {

		let totalS10EstoqueManual = 0;
		let totalS10EstoqueBase = 0;
		let totalS10SobreRodas = 0;
		let totalS10SobreRodasBase = 0;
		let totalS10Faturar = 0;
		let totalS10Faturado = 0;
		let totalS10Disponibilidade = 0;
		let totalS10Programado = 0;

		let totalS500EstoqueManual = 0;
		let totalS500EstoqueBase = 0;
		let totalS500SobreRodas = 0;
		let totalS500SobreRodasBase = 0;
		let totalS500Faturar = 0;
		let totalS500Faturado = 0;
		let totalS500Disponibilidade = 0;
		let totalS500Programado = 0;

		const configuracaoTanques = [{
			id: 1,
			nome: 'Capacidade: 80m³',
			id_unidade: 1,
			id_produto: 1,
			capacidade: 20000
		},
		//1-ÁGUA BOA
		//3-S500
		{
			id: 5,
			nome: 'Capacidade: 40m³',
			id_unidade: 1,
			id_produto: 3,
			capacidade: 20000
		},
		//3-BARRA DO GARÇAS
		//1-S10
		{
			id: 7,
			nome: 'Capacidade: 180m³',
			id_unidade: 3,
			id_produto: 1,
			capacidade: 60000
		},
		//3-BARRA DO GARÇAS
		//3-S500
		{
			id: 10,
			nome: 'Capacidade: 120m³',
			id_unidade: 3,
			id_produto: 3,
			capacidade: 60000
		},
		//9-PORTO ALEGRE DO NORTE
		//1-S10
		{
			id: 12,
			nome: 'Capacidade: 150m³',
			id_unidade: 9,
			id_produto: 1,
			capacidade: 60000
		},
		//9-PORTO ALEGRE DO NORTE
		//3-S500
		{
			id: 15,
			nome: 'Capacidade: 90m³',
			id_unidade: 9,
			id_produto: 3,
			capacidade: 60000
		},
		//60 - RIO VERDE (SERTÃO)
		//1-S10
		{
			id: 17,
			nome: 'Tanque 1 de 60m³',
			id_unidade: 60,
			id_produto: 1,
			capacidade: 60000,
			quantidade: 0
		}, {
			id: 18,
			nome: 'Tanque 2 de 60m³',
			id_unidade: 60,
			id_produto: 1,
			capacidade: 60000,
			quantidade: 0
		}, {
			id: 19,
			nome: 'Tanque 3 de 60m³',
			id_unidade: 60,
			id_produto: 3,
			capacidade: 60000,
			quantidade: 0
		}, {
			id: 20,
			nome: 'Tanque 4 de 60m³',
			id_unidade: 60,
			id_produto: 3,
			capacidade: 60000,
			quantidade: 0
		}];

		const listaUnidadeFiltrada = this.props.listaUnidade.filter(unidade => !unidade.valor.toUpperCase().includes('DIRETA')).filter(unidade => {
			return !(this.state.filtro.id_unidades || []).length || (this.state.filtro.id_unidades || []).includes(unidade.id);
		});

        return (
			<Content>
				<div className="db-dashboard" style={{ background: TOKENS.bg, margin: -16, padding: 16 }}>

					{/* CSS global do dashboard — não depende de className nos componentes de tabela */}
					<style>{`
						.db-dashboard table { border-collapse: separate !important; border-spacing: 0 !important; width: 100%; }
						.db-dashboard thead tr { background: ${TOKENS.headerGradientSoft} !important; }
						.db-dashboard thead th {
							color: #f1f5f9 !important;
							font-weight: 600 !important;
							font-size: 12px !important;
							text-transform: uppercase;
							letter-spacing: .6px;
							padding: 4px 2px !important;
							border: none !important;
						}
						.db-dashboard tbody tr { transition: background-color .15s ease; }
						.db-dashboard tbody tr:hover { background-color: #f8fafc !important; }
						.db-dashboard tbody td {
							padding: 4px !important;
							border-bottom: 1px solid ${TOKENS.border} !important;
							font-size: 14px;
							color: ${TOKENS.textPrimary};
						}
						.db-dashboard .db-card {
							background: ${TOKENS.cardBg};
							border-radius: ${TOKENS.cardRadius}px;
							box-shadow: ${TOKENS.cardShadow};
							overflow: hidden;
							margin-bottom: 8px;
							border: 1px solid ${TOKENS.border};
						}
						.db-dashboard .db-card-header {
							background: ${TOKENS.headerGradient};
							padding: 4px 22px;
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
						.db-dashboard .db-card-header label {
							color: #fff;
							font-size: 15px;
							font-weight: 600;
							letter-spacing: .2px;
							margin: 0;
						}
						.db-dashboard .db-table-wrap { overflow-x: auto; }
						.db-dashboard .db-loan-box {
							border-radius: 14px;
							padding: 16px 18px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							box-shadow: 0 1px 2px rgba(15,23,42,.05);
							border: 1px solid rgba(15,23,42,.05);
						}
					`}</style>

					{/* Cabeçalho + filtro */}
					
						<Select
							options={this.props.listaUnidade.filter(unidade => !unidade.valor.toUpperCase().includes('DIRETA'))}
							label='Unidade'
							cols='12 12 12 12'
							placeholder='Selecione'
							multiple={true}
							value={this.props.listaUnidade.filter(unidade => !unidade.valor.toUpperCase().includes('DIRETA')).filter(unidade => {
								return (this.state.filtro.id_unidades || []).includes(unidade.id);
							}).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setFiltro({ ...this.state.filtro, id_unidades: (values || []).map(item => item.value) })
							}} />
					

					{this.state.itens ? this.modalItens() : null}

					{listaUnidadeFiltrada.filter(unidade => this.props.lista.filter(item => item.id_unidade == unidade.id).length).map(unidade => {

						let totalEstoqueManual = 0;
						let totalEstoqueBase = 0;
						let totalSobreRodas = 0;
						let totalSobreRodasBase = 0;
						let totalFaturar = 0;
						let totalFaturado = 0;
						let totalDisponibilidade = 0;
						let totalProgramado = 0;

						return (
							<div className="db-card" key={unidade.id}>
								<div className="db-card-header">
									<label>Saldos — {unidade.valor}</label>
								</div>
								<div className="db-table-wrap">
									<Table responsive marginBottom={0} >
										<THead>
											<Tr>
												<Th alignCenter></Th>
												{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
												<Th alignCenter>Estoque Manual</Th>*/}
												<Th alignCenter>Estoque Base</Th>
												<Th alignCenter>
													<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
														<div style={{ width: '50%' }}>Sobre Rodas Viagem</div>
														<div style={{ width: '50%' }}>Sobre Rodas Base</div>
													</div>
												</Th>
												<Th alignCenter>À Faturar</Th>
												<Th alignCenter>Faturado (não carregado)</Th>
												<Th alignCenter>Disponibilidade</Th>
												<Th alignCenter>Programado para Estoque</Th>
											</Tr>
										</THead>
										<TBody>
											{this.props.listaProduto.map(produto => {

												let registroManual = null;//this.props.listaManual.filter(manual => manual.id_unidade == unidade.id && manual.id_produto == produto.id).pop();

												let estoqueManual = parseFloat(registroManual ? registroManual.quantidade : 0);

												let tanques = this.props.lista.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id && item.status == 'ESTOQUE BASE')[0]
												let rodas = this.props.lista.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id && item.status == 'SOBRE RODAS')[0]
												let faturar = this.props.lista.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id && item.status == 'À FATURAR')[0]
												let faturado = this.props.lista.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id && item.status == 'FATURADO (NÃO CARREGADO)')[0]

												let acessoPedro = false;//(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4));

												let disponibilidade = parseFloat(this.buscarSaldoEstoqueBase(unidade.id, produto.id)) + parseFloat(rodas ? rodas.quantidade : 0)
													- parseFloat(faturar ? faturar.quantidade : 0) - parseFloat(faturado ? faturado.quantidade : 0);
												let programado = this.props.lista.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id && item.status == 'PROGRAMADO')[0]

												let listaAux = this.props.lista.filter(item => item.id_unidade == unidade.id
													&& item.id_produto == produto.id
													&& item.status != 'PROGRAMADO'
												);

												totalEstoqueManual += estoqueManual;
												totalEstoqueBase += parseFloat(this.buscarSaldoEstoqueBase(unidade.id, produto.id));
												totalSobreRodas += parseFloat(listaAux[1].quantidade || 0);
												totalSobreRodasBase += parseFloat(listaAux[1].quantidade_sobre_rodas_base || 0);
												totalFaturar += parseFloat(listaAux[2].quantidade || 0);
												totalFaturado += parseFloat(listaAux[3].quantidade || 0);
												totalDisponibilidade += parseFloat(disponibilidade || 0);
												totalProgramado += parseFloat(programado ? programado.quantidade : 0);

												if (produto.id == 1) {
													totalS10EstoqueManual += estoqueManual;
													totalS10EstoqueBase += parseFloat(this.buscarSaldoEstoqueBase(unidade.id, produto.id));
													totalS10SobreRodas += parseFloat(listaAux[1].quantidade || 0);
													totalS10SobreRodasBase += parseFloat(listaAux[1].quantidade_sobre_rodas_base || 0);
													totalS10Faturar += parseFloat(listaAux[2].quantidade || 0);
													totalS10Faturado += parseFloat(listaAux[3].quantidade || 0);
													totalS10Disponibilidade += parseFloat(disponibilidade || 0);
													totalS10Programado += parseFloat(programado ? programado.quantidade : 0);
												} else {
													totalS500EstoqueManual += estoqueManual;
													totalS500EstoqueBase += parseFloat(this.buscarSaldoEstoqueBase(unidade.id, produto.id));
													totalS500SobreRodas += parseFloat(listaAux[1].quantidade || 0);
													totalS500SobreRodasBase += parseFloat(listaAux[1].quantidade_sobre_rodas_base || 0);
													totalS500Faturar += parseFloat(listaAux[2].quantidade || 0);
													totalS500Faturado += parseFloat(listaAux[3].quantidade || 0);
													totalS500Disponibilidade += parseFloat(disponibilidade || 0);
													totalS500Programado += parseFloat(programado ? programado.quantidade : 0);
												}

												let estoqueMinimo = 0;
												if (produto.id == 1) {
													estoqueMinimo = unidade.estoque_minimo_s10;
												} else {
													estoqueMinimo = unidade.estoque_minimo_s500;
												}
												const statusKey = this.classificarDisponibilidade(disponibilidade, estoqueMinimo);
												const statusCor = STATUS_DISPONIBILIDADE[statusKey];
												const produtoCor = PRODUTO_STYLE[produto.id] || PRODUTO_STYLE[1];

												return (
													<Tr key={produto.id}>

														<Td alignCenter
															title={
																configuracaoTanques.filter(tanque => tanque.id_unidade == unidade.id && tanque.id_produto == produto.id).map(tanque => {
																	return `${tanque.nome} \n`;
																}).join('\n')
															}>
															<span style={pillStyle(produtoCor.bg, produtoCor.text)}>
																{produto.valor}
															</span>
														</Td>
														{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
														<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(estoqueManual, 0)}</Td>*/}

														{this.props.lista.filter(item => item.id_unidade == unidade.id
															&& item.id_produto == produto.id
															&& item.status != 'PROGRAMADO'
														).map((item, i) => {

															let lista = [];
															if (item.status == 'SOBRE RODAS') {
																lista = this.props.listaEntrada.filter(entrada =>
																	entrada.id_unidade == item.id_unidade
																	&& entrada.id_produto == item.id_produto
																	&& entrada.status == item.status
																).map(entrada => ({
																	...entrada,
																	valor_total:  parseFloat(entrada.quantidade) * parseFloat(entrada.preco)
																}));

																lista = lista.concat(this.props.listaTransferencia.filter(transferencia =>
																	(transferencia.id_unidade_destino == item.id_unidade)
																	&& transferencia.id_produto == item.id_produto
																	&& transferencia.status == item.status
																).map(transferencia => ({
																	...transferencia,
																	valor_total:  parseFloat(transferencia.quantidade) * parseFloat(transferencia.preco)
																})));
															} else if (item.status == 'À FATURAR' || item.status == 'FATURADO (NÃO CARREGADO)') {
																lista = this.props.listaSaida.filter(saida =>
																	saida.id_unidade == item.id_unidade
																	&& saida.id_produto == item.id_produto
																	&& saida.status == item.status
																);
															}

															return (
																<Td key={i} alignCenter
																	title={
																		lista.map(mov => {

																			let telemetria = this.props.listaPosicaoVeiculo.filter(telemetria => telemetria.placa == mov.placa_veiculo)[0];

																			return `${mov.giro ? `GIRO ${mov.giro} | ` : ''}${mov.placa_veiculo || 'Sem Veículo'} | ${mov.nome_motorista || (telemetria && telemetria.telemetria ? telemetria.telemetria.motorista : null) || 'Sem Motorista'}${telemetria && telemetria.telemetria && telemetria.telemetria.localizacao ? ` | ${telemetria.telemetria.localizacao}` : ''} | ${mov.nome_distribuidora || mov.nome_cliente || 'Sem Distribuidora'}${mov.transportadora ? ` | ${mov.transportadora}` : ''} | ${FormatUtils.formatarValorTelaDecimal(mov.quantidade, 0)} litros ${mov.preco > 0 ? `| R$ ${FormatUtils.formatarValorTela(mov.preco, 4)}` : ''} ${mov.valor_total > 0 ? `| R$ ${FormatUtils.formatarValorTelaDecimal(mov.valor_total, 2)}` : ''} ${mov.prazo != null ? `| ${mov.prazo == 0 ? 'À vista' : (mov.prazo == 1 ? '1 dia' : `${mov.prazo} dias`)}` : ''} \n`;
																		}).join('\n')
																	}
																	onClick={() => {
																		if (!lista.length) {
																			// window.alert('Nenhum registro encontrado');
																		} else {
																			this.setDialogItens(lista.map(mov => {

																				let telemetria = this.props.listaPosicaoVeiculo.filter(telemetria => telemetria.placa == mov.placa_veiculo)[0];

																				return {
																					descricao: `${mov.giro ? `GIRO ${mov.giro} | ` : ''}${mov.placa_veiculo || 'Sem Veículo'} | ${mov.nome_motorista || (telemetria && telemetria.telemetria ? telemetria.telemetria.motorista : null) || 'Sem Motorista'}${telemetria && telemetria.telemetria && telemetria.telemetria.localizacao ? ` | ${telemetria.telemetria.localizacao}` : ''} | ${mov.nome_distribuidora || mov.nome_cliente || 'Sem Distribuidora'}${mov.transportadora ? ` | ${mov.transportadora}` : ''} | ${FormatUtils.formatarValorTelaDecimal(mov.quantidade, 0)} litros ${mov.preco > 0 ? `| R$ ${FormatUtils.formatarValorTela(mov.preco, 4)}` : ''} ${mov.valor_total > 0 ? `| R$ ${FormatUtils.formatarValorTelaDecimal(mov.valor_total, 2)}` : ''} ${mov.prazo != null ? `| ${mov.prazo == 0 ? 'À vista' : (mov.prazo == 1 ? '1 dia' : `${mov.prazo} dias`)}` : ''} \n`,
																					latitude: telemetria && telemetria.telemetria ? telemetria.telemetria.latitude : null,
																					longitude: telemetria && telemetria.telemetria ? telemetria.telemetria.longitude : null
																				}
																			}));
																		}
																	}}
																	>{item.status != 'SOBRE RODAS' ? (
																		item.status == 'ESTOQUE BASE' ? (
																			FormatUtils.formatarValorTelaDecimal(this.buscarSaldoEstoqueBase(unidade.id, produto.id), 0)
																		) : (
																			FormatUtils.formatarValorTelaDecimal(parseFloat(item.quantidade), 0)
																		)
																	) : (
																		<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
																			<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(parseFloat(item.quantidade) - parseFloat(item.quantidade_sobre_rodas_base || 0), 0)}</div>
																			<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(item.quantidade_sobre_rodas_base, 0)}</div>
																		</div>
																	)}
																</Td>
															);
														})}
														<Td alignCenter>
															<span style={pillStyle(statusCor.bg, statusCor.text)}>
																{FormatUtils.formatarValorTelaDecimal(disponibilidade, 0)}
															</span>
														</Td>
														<Td title={
																this.props.listaEntrada.filter(entrada =>
																	entrada.id_unidade == unidade.id
																	&& entrada.id_produto == produto.id
																	&& entrada.status == 'PROGRAMADO'
																).map(entrada => {

																	let telemetria = this.props.listaPosicaoVeiculo.filter(telemetria => telemetria.placa == entrada.placa_veiculo)[0];

																	return `${entrada.placa_veiculo || 'Sem Veículo'} | ${entrada.nome_motorista || 'Sem Motorista'}${telemetria && telemetria.telemetria && telemetria.telemetria.localizacao ? ` | ${telemetria.telemetria.localizacao}` : ''} | ${entrada.nome_distribuidora || 'Sem Distribuidora'}${entrada.transportadora ? ` | ${entrada.transportadora}` : ''} | ${FormatUtils.formatarValorTela(entrada.quantidade, 0)} litros ${entrada.preco > 0 ? `| R$ ${FormatUtils.formatarValorTela(entrada.preco, 4)}` : ''} ${entrada.preco > 0 ? `| R$ ${FormatUtils.formatarValorTelaDecimal(parseFloat(entrada.quantidade) * parseFloat(entrada.preco), 2)}` : ''}`
																}).join('\n')
																+ '\n' +
																this.props.listaTransferencia.filter(transferencia =>
																	(transferencia.id_unidade_destino == unidade.id)
																	&& transferencia.id_produto == produto.id
																	&& transferencia.status == 'PROGRAMADO'
																).map(transferencia => {

																	let telemetria = this.props.listaPosicaoVeiculo.filter(telemetria => telemetria.placa == transferencia.placa_veiculo)[0];

																	return `${transferencia.placa_veiculo || 'Sem Veículo'} | ${transferencia.nome_motorista || 'Sem Motorista'}${telemetria && telemetria.telemetria && telemetria.telemetria.localizacao ? ` | ${telemetria.telemetria.localizacao}` : ''} | ${transferencia.nome_distribuidora || 'Sem Distribuidora'}${transferencia.transportadora ? ` | ${transferencia.transportadora}` : ''} | ${FormatUtils.formatarValorTela(transferencia.quantidade, 0)} litros ${transferencia.preco > 0 ? `| R$ ${FormatUtils.formatarValorTela(transferencia.preco, 4)}` : ''} ${transferencia.preco > 0 ? `| R$ ${FormatUtils.formatarValorTelaDecimal(parseFloat(transferencia.quantidade) * parseFloat(transferencia.preco), 2)}` : ''}`
																}).join('\n')
															}
															onClick={() => {
																let lista = this.props.listaEntrada.filter(entrada =>
																	entrada.id_unidade == unidade.id
																	&& entrada.id_produto == produto.id
																	&& entrada.status == 'PROGRAMADO'
																);
																lista = lista.concat(this.props.listaTransferencia.filter(transferencia =>
																	(transferencia.id_unidade_destino == unidade.id)
																	&& transferencia.id_produto == produto.id
																	&& transferencia.status == 'PROGRAMADO'
																));

																if (!lista.length) {
																	// window.alert('Nenhum registro encontrado');
																} else {
																	this.setDialogItens(lista.map(entrada => {

																		let telemetria = this.props.listaPosicaoVeiculo.filter(telemetria => telemetria.placa == entrada.placa_veiculo)[0];

																		return {
																			descricao: `${entrada.placa_veiculo || 'Sem Veículo'} | ${entrada.nome_motorista || 'Sem Motorista'}${telemetria && telemetria.telemetria && telemetria.telemetria.localizacao ? ` | ${telemetria.telemetria.localizacao}` : ''} | ${entrada.nome_distribuidora || 'Sem Distribuidora'}${entrada.transportadora ? ` | ${entrada.transportadora}` : ''} | ${FormatUtils.formatarValorTela(entrada.quantidade, 0)} litros ${entrada.preco > 0 ? `| R$ ${FormatUtils.formatarValorTela(entrada.preco, 4)}` : ''} ${entrada.preco > 0 ? `| R$ ${FormatUtils.formatarValorTelaDecimal(parseFloat(entrada.quantidade) * parseFloat(entrada.preco), 2)}` : ''}`,
																			latitude: telemetria && telemetria.telemetria ? telemetria.telemetria.latitude : null,
																			longitude: telemetria && telemetria.telemetria ? telemetria.telemetria.longitude : null
																		}
																	}));
																}
															}}
															alignCenter>
															<span style={pillStyle(PROGRAMADO_STYLE.bg, PROGRAMADO_STYLE.text)}>
																{FormatUtils.formatarValorTelaDecimal(programado ? programado.quantidade : 0, 0)}
															</span>
														</Td>

													</Tr>
												);
											})}

											<Tr backgroundColor={'#f8fafc'}>
												<Td alignRight width={100} bold fontSize={15}>TOTAL</Td>
												{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
												<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalEstoqueManual, 0)}</Td>*/}
												<Td alignCenter width={100} bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totalEstoqueBase, 0)}</Td>
												<Td alignCenter width={200} bold fontSize={15}>
													<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
														<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalSobreRodas - totalSobreRodasBase, 0)}</div>
														<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalSobreRodasBase, 0)}</div>
													</div>
												</Td>
												<Td alignCenter width={100} bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totalFaturar, 0)}</Td>
												<Td alignCenter width={100} bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totalFaturado, 0)}</Td>
												<Td alignCenter width={100} bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totalDisponibilidade, 0)}</Td>
												<Td alignCenter width={100} bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totalProgramado, 0)}</Td>
											</Tr>

										</TBody>
									</Table>
								</div>
							</div>
						);
					})}

					<div className="db-card">
						<div className="db-card-header">
							<label>Total das Unidades</label>
						</div>
						<div className="db-table-wrap">
							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter></Th>
										{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
										<Th alignCenter>Estoque Manual</Th>*/}
										<Th alignCenter>Estoque Base</Th>
										<Th alignCenter>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
												<div style={{ width: '50%' }}>Sobre Rodas Viagem</div>
												<div style={{ width: '50%' }}>Sobre Rodas Base</div>
											</div>
										</Th>
										<Th alignCenter>À Faturar</Th>
										<Th alignCenter>Faturado (não carregado)</Th>
										<Th alignCenter>Disponibilidade</Th>
										<Th alignCenter>Programado para Estoque</Th>
									</Tr>
								</THead>
								<TBody>
									<Tr>
										<Td alignCenter width={100}>
											<span style={pillStyle(PRODUTO_STYLE[1].bg, PRODUTO_STYLE[1].text)}>
												B S10 ADITIVADO
											</span>
										</Td>
										{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS10EstoqueManual, 0)}</Td>*/}
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS10EstoqueBase, 0)}</Td>
										<Td alignCenter width={200}>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
												<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalS10SobreRodas - totalS10SobreRodasBase, 0)}</div>
												<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalS10SobreRodasBase, 0)}</div>
											</div>
										</Td>
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS10Faturar, 0)}</Td>
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS10Faturado, 0)}</Td>
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS10Disponibilidade, 0)}</Td>
										<Td alignCenter width={100}>
											<span style={pillStyle(PROGRAMADO_STYLE.bg, PROGRAMADO_STYLE.text)}>
												{FormatUtils.formatarValorTelaDecimal(totalS10Programado, 0)}
											</span>
										</Td>
									</Tr>
									<Tr>
										<Td alignCenter width={100}>
											<span style={pillStyle(PRODUTO_STYLE[3].bg, PRODUTO_STYLE[3].text)}>
												B S500 ADITIVADO
											</span>
										</Td>
										{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS500EstoqueManual, 0)}</Td>*/}
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS500EstoqueBase, 0)}</Td>
										<Td alignCenter width={200}>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
												<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalS500SobreRodas - totalS500SobreRodasBase, 0)}</div>
												<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalS500SobreRodasBase, 0)}</div>
											</div>
										</Td>
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS500Faturar, 0)}</Td>
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS500Faturado, 0)}</Td>
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS500Disponibilidade, 0)}</Td>
										<Td alignCenter width={100}>
											<span style={pillStyle(PROGRAMADO_STYLE.bg, PROGRAMADO_STYLE.text)}>
												{FormatUtils.formatarValorTelaDecimal(totalS500Programado, 0)}
											</span>
										</Td>
									</Tr>
									<Tr backgroundColor={'#f8fafc'}>
										<Td alignRight width={100} bold fontSize={16}>TOTAL</Td>
										{/*(this.props.sessao && (this.props.sessao.id == 1 || this.props.sessao.id == 4)) &&
										<Td alignCenter width={100}>{FormatUtils.formatarValorTelaDecimal(totalS10EstoqueManual + totalS500EstoqueManual, 0)}</Td>*/}
										<Td alignCenter width={100} bold fontSize={16}>{FormatUtils.formatarValorTelaDecimal(totalS10EstoqueBase + totalS500EstoqueBase, 0)}</Td>
										<Td alignCenter width={200} bold fontSize={16}>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
												<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalS10SobreRodas + totalS500SobreRodas - totalS10SobreRodasBase - totalS500SobreRodasBase, 0)}</div>
												<div style={{ width: '50%' }}>{FormatUtils.formatarValorTelaDecimal(totalS10SobreRodasBase + totalS500SobreRodasBase, 0)}</div>
											</div>
										</Td>
										<Td alignCenter width={100} bold fontSize={16}>{FormatUtils.formatarValorTelaDecimal(totalS10Faturar + totalS500Faturar, 0)}</Td>
										<Td alignCenter width={100} bold fontSize={16}>{FormatUtils.formatarValorTelaDecimal(totalS10Faturado + totalS500Faturado, 0)}</Td>
										<Td alignCenter width={100} bold fontSize={16}>{FormatUtils.formatarValorTelaDecimal(totalS10Disponibilidade + totalS500Disponibilidade, 0)}</Td>
										<Td alignCenter width={100} bold fontSize={16}>{FormatUtils.formatarValorTelaDecimal(totalS10Programado + totalS500Programado, 0)}</Td>
									</Tr>
								</TBody>
							</Table>
						</div>
					</div>

					<div className="db-card">
						<div className="db-card-header">
							<label>Empréstimos</label>
						</div>
						<div style={{ padding: 18 }}>
							<Row>
								{listaUnidadeFiltrada.filter(unidade => this.props.listaTerceiro.filter(item => item.id_unidade == unidade.id).length).map(unidade => (

									this.props.listaTerceiro.filter(item => item.id_unidade == unidade.id).map((item, i) => {
										const cor = PRODUTO_STYLE[item.id_produto] || PRODUTO_STYLE[1];
										return (
											<div key={i} class='col-lg-3 col-6' style={{ marginBottom: 16 }}>
												<div className="db-loan-box" style={{ background: cor.bg }}>
													<div>
														<div style={{ fontSize: 16, color: TOKENS.textMuted, marginTop: 6, fontWeight: 'bold' }}>
															{unidade.valor}
														</div>
														<div style={{ fontSize: 20, fontWeight: 700, color: cor.text }}>
															{FormatUtils.formatarValorTelaDecimal(item.quantidade, 0)} L
														</div>
														<div style={{ fontSize: 12, fontWeight: 600, color: cor.text, opacity: .85, marginTop: 2 }}>
															{cor.label}
														</div>
														<div style={{ fontSize: 13, color: TOKENS.textMuted, marginTop: 6 }}>
															{item.nome_terceiro}
														</div>
													</div>
												</div>
											</div>
										);
									})

								))}
							</Row>
						</div>
					</div>
				</div>
			</Content>
        )
	}

	setDialogItens(itens) {
		this.setState({
			...this.state,
			itens: itens
		})
	}

	modalItens() {

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content' style={{ borderRadius: 14, border: 'none', boxShadow: '0 12px 40px rgba(15,23,42,.25)', overflow: 'hidden' }}>
						<div class='modal-header' style={{ background: TOKENS.headerGradient, border: 'none', padding: '16px 22px' }}>
							<h4 class='modal-title' style={{ color: '#fff', margin: 0 }}>Detalhes</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setDialogItens(null)} style={{ color: '#fff', opacity: .85 }}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: '80%', padding: 20 }}>
							<Row>
								{(this.state.itens || []).map(item => (
									<p key={item.descricao} style={{
										padding: '10px 14px',
										background: '#f8fafc',
										borderRadius: 10,
										border: `1px solid ${TOKENS.border}`,
										marginBottom: 8,
										fontSize: 13.5
									}}>
										{item.descricao}
										{(item.latitude && item.longitude) &&
										<a style={{ paddingLeft: 4, color: TOKENS.accent, fontWeight: 600 }} href={`https://www.google.com/maps/place/${item.latitude},${item.longitude}`} target='_blank'>(Abrir no Mapa)</a>}
									</p>
								))}
							</Row>
						</div>
						<div class='modal-footer justify-content-between' style={{ border: 'none', padding: '14px 22px' }}>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								style={{ background: TOKENS.accent, border: 'none', borderRadius: 8, padding: '8px 20px', fontWeight: 600 }}
								onClick={() => {
									this.setDialogItens(null);
								}}>Ok</button>
						</div>
					</div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboard.aguardando,
	listaEstoqueBase: state.dashboard.listaEstoqueBase,
	lista: state.dashboard.lista,
	listaTerceiro: state.dashboard.listaTerceiro,
	listaEntrada: state.dashboard.listaEntrada,
	listaSaida: state.dashboard.listaSaida,
	listaTransferencia: state.dashboard.listaTransferencia,
	listaUnidade: state.dashboard.listaUnidade,
	listaProduto: state.dashboard.listaProduto.filter(item => item.id == 1 || item.id == 3),
	listaPosicaoVeiculo: state.dashboard.listaPosicaoVeiculo,
	listaManual: state.dashboard.listaManual
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getLista, getListaTerceiros, getListaEntradas, getListaSaidas, getListaTransferencias, getListaUnidade, getListaProduto, getListaPosicaoVeiculo, getListaManual, getListaEstoqueBase
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)